import classNames from 'classnames';
import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  containerClass?: string;
  onClick?: () => void;
}

export const Badge = ({ children, containerClass, onClick }: BadgeProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        'text-nowrap text-[14px] px-2 flex items-center justify-center overflow-hidden',
        {
          'rounded-full': !containerClass?.includes('rounded-'),
          'bg-gray-200': !containerClass?.includes('bg-'),
          'py-1': !containerClass?.includes('py-'),
          'text-gray-600': !containerClass?.includes('text-'),
        },
        containerClass,
      )}
    >
      {children}
    </div>
  );
};
